export default "__VITE_ASSET__Bjm68158__"